/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";

import { Stack } from "@mui/material";
import { News, SuggestedMemberOverview, SuggestedMembers } from "components/Freemium";
import { useDevice } from "hooks";

import { mockNewsItems } from "./mock_news";
import { mockSuggestedMembers, SuggestedMember } from "./mock_suggested_members";

export const Community: React.FC = () => {
  const [memberOverview, setMemberOverview] = useState<SuggestedMember>(mockSuggestedMembers[0]);

  const suggestedMembersList = mockSuggestedMembers.map(({ id, name, role, avatar }) => ({
    id,
    name,
    role,
    avatar
  }));

  const { isMobile } = useDevice();

  return (
    <Stack
      sx={{
        width: "100%",
        gap: "20px",
        ...(isMobile
          ? { flexDirection: "column-reverse", overflowY: "auto", overflowX: "hidden" }
          : { flexDirection: "row", overflow: "hidden", alignItems: "flex-start" })
      }}
    >
      {/* Left Column - News Cards */}
      <Stack
        sx={{
          flexGrow: 1,
          gap: "20px",
          ...(isMobile
            ? {
                maxWidth: "100%",
                minWidth: "100%"
              }
            : {
                overflow: "auto",
                maxHeight: "100%"
              })
        }}
      >
        {mockNewsItems.map((newsItem) => (
          <News key={newsItem.id} newsItem={newsItem} />
        ))}
      </Stack>

      {/* Right Sidebar */}
      <Stack
        sx={{
          flex: "1 1 auto",
          gap: "20px",
          ...(isMobile
            ? { maxWidth: "100%", minWidth: "100%" }
            : { overflow: "auto", maxHeight: "100%", maxWidth: "386px", minWidth: "386px" })
        }}
      >
        <SuggestedMembers
          people={suggestedMembersList}
          allMembers={mockSuggestedMembers}
          onMemberClick={setMemberOverview}
        />
        <SuggestedMemberOverview
          name={memberOverview.name}
          role={memberOverview.role}
          company={memberOverview.company}
          location={memberOverview.location}
          bio={memberOverview.bio}
          coverImage={`https://www.figma.com/api/mcp/asset/${memberOverview.avatar}`}
        />
      </Stack>
    </Stack>
  );
};
